<template>
  <div class="districtMapWrapper" ref="container" v-bind:style="style.setHeight">
    <div class="fragImgDiv">
      <img v-bind:src="baseMapImg" ref="baseMapImg">
    </div>
    <div class="fragImgDiv" v-for="(fragImg, index) in fragMapImg" v-bind:key="'fragImg' + index">
      <img v-bind:src="fragImg.img">
    </div>
    <div class="rateTextBox" v-for="(fragRate, index) in fragRateTextData" v-show="fragRate.rate > 0"
         v-bind:key="'fragRate' + index" v-bind:style="fragRate.style">
      <div class="textBoxFrag">
        <span>{{fragRate.rate + '%'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import params from '../../../params'

export default {
  props: {
    districtRateData: Array
  },
  data () {
    return {
      baseMapImg: require('@/assets/img/mapFragment/base_map.png'),
      rateData: null,
      fragMapImg: [],
      fragRateTextData: [],
      fragPositionInfo: params.mapFragInfo,
      style: {
        setHeight: null
      }
    }
  },
  methods: {
    setContainerHeight: function () {
      // width값의 1.5배로 heigth 설정
      this.style.setHeight = 'height: ' + (this.$refs.container.clientWidth * 1.5) + 'px;'
    },
    setFragMapImg: function () {
      for(var i = 0; i < this.rateData.length; i++) {
        if(this.rateData[i].districtRate > 0) {
        // rate 데이터가 있을 시 (0 이상일 시) 지도frag 셋팅
          let fileName = this.fragPositionInfo.find(items => items.type === this.rateData[i].regionName).fileName
          this.fragMapImg.push({
            img: require('@/assets/img/mapFragment/' + fileName)
          })
        }
      }
    },
    setFragRateTextData: function () {
      for(var i = 0; i < this.rateData.length; i++) {
        let topPosition = this.fragPositionInfo.find(items => items.type === this.rateData[i].regionName).top
        let leftPosition = this.fragPositionInfo.find(items => items.type === this.rateData[i].regionName).left

        if(this.fragRateTextData.find(items => items.type === this.rateData[i].regionName) != null) {
          // 이미 같은 region의 데이터가 있을 경우
          this.fragRateTextData.find(items => items.type === this.rateData[i].regionName).rate += this.rateData[i].districtRate
        }else{
          // 같은 region의 데이터가 없을 경우 push
          this.fragRateTextData.push({
            type: this.rateData[i].regionName,
            rate: this.rateData[i].districtRate,
            style: 'top: ' + topPosition + '; ' + 'left: ' + leftPosition + ';'
          })
        }
      }
    }
  },
  mounted: function () {
    // 맵비율인 가로세로 1:1.5비율로 컨테이너 비율도 맞춤
    this.setContainerHeight()
  },
  watch: {
    districtRateData: function () {
      this.rateData = this.districtRateData
      this.setFragMapImg()
      this.setFragRateTextData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width: 100%;
  height: auto;
}

.districtMapWrapper{
  position: relative;
  padding: 0;
  margin: 0;
  /*height: ;*/
}

.fragImgDiv{
  position: absolute;
  left: 0;
  top: 0;
}

.rateTextBox{
  position: absolute;
  width: 30px;
  height: 30px;
}

.textBoxFrag{
  position: relative;
  width: 29px;
  height: 20px;
  padding-top: 5px;
  text-align: center;
  font-size: 9px;
  border-radius: 0.25rem;
  background-color: #0099ff;
  color: white;
}

.textBoxFrag:after {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-top-color: #0099ff;
  border-width: 5px;
  margin-left: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/districtMap.vue